import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { FileBarChart, Printer, Table2, Mail, ChevronDown, Loader2 } from "lucide-react";

// Reports Final UI Polish — one consistent "Get Report" control replacing the scattered individual
// Print/CSV/Email buttons previously spread across the Business, Products, NEEC MONEY and
// Purchasing tabs. Scope restored per Owner review 2026-10-30: this consolidates EXISTING actions
// only (Print / Save as PDF via the browser, Download CSV, Email Report) — no standalone
// server-generated "Download PDF" action. Built on Radix's DropdownMenu (already in the design
// system), which provides close-on-outside-click, close-on-Escape, close-on-select, full keyboard
// navigation and hover/focus states with zero extra code.
export default function GetReportButton({ onPrint, onDownloadCsv, onEmail, canEmail, busy, disabled, testidPrefix }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={!!busy || !!disabled} data-testid={`${testidPrefix}-get-report-btn`}>
          {busy ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <FileBarChart className="w-4 h-4 mr-1.5" />}
          Get Report
          <ChevronDown className="w-3.5 h-3.5 ml-1.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52" data-testid={`${testidPrefix}-get-report-menu`}>
        <DropdownMenuItem onClick={onPrint} data-testid={`${testidPrefix}-action-print`}><Printer className="w-4 h-4" /> Print / Save as PDF</DropdownMenuItem>
        <DropdownMenuItem onClick={onDownloadCsv} data-testid={`${testidPrefix}-action-csv`}><Table2 className="w-4 h-4" /> Download CSV</DropdownMenuItem>
        {canEmail && <>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={onEmail} data-testid={`${testidPrefix}-action-email`}><Mail className="w-4 h-4" /> Email Report</DropdownMenuItem>
        </>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

